export default __webpack_public_path__ + "static/media/eth-logo.9270fc02.svg";